exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-anexo[data-v-3210667e]{\n    opacity: 0.8;\n}\n.image-anexo[data-v-3210667e]:hover{\n    opacity: 1;\n}\n", ""]);

// exports
